// extracted by mini-css-extract-plugin
module.exports = {"animation":"wealth-mini-product-card_animation__SYCRH","skeletonShimmer":"wealth-mini-product-card_skeletonShimmer__9SvY_"};